import type { TaxCalculationInput, TaxCalculationResult } from '../types/payment.types';

export type { TaxCalculationInput, TaxCalculationResult };

/**
 * Calculates GST, TDS, and net payable amounts based on a base fee.
 *
 * Formula:
 *   netPayable = baseFee + gstAmount - tdsAmount
 *
 * Both GST and TDS are computed as a percentage of the base fee.
 */
export const calculateTaxAmounts = ({
  baseFee,
  includeGst,
  gstPercentage,
  includeTds,
  tdsPercentage,
}: TaxCalculationInput): TaxCalculationResult => {
  let gstAmount = 0;
  let tdsAmount = 0;

  if (includeGst && baseFee > 0) {
    gstAmount = (baseFee * gstPercentage) / 100;
  }

  if (includeTds && baseFee > 0) {
    tdsAmount = (baseFee * tdsPercentage) / 100;
  }

  return {
    gstAmount,
    tdsAmount,
    netPayable: baseFee + gstAmount - tdsAmount,
  };
};
